import { useQuery } from "@tanstack/react-query";
import { CheckCircle2, XCircle } from "lucide-react";
import { riderApi, type Delivery } from "@/features/delivery/api";

const rupee = (n: number) => `₹${n.toLocaleString("en-IN")}`;

export default function RiderHistory() {
    const { data = [], isLoading } = useQuery<Delivery[]>({
        queryKey: ["rider", "history"],
        queryFn: riderApi.history,
    });

    if (isLoading) return <p className="text-sm text-muted-foreground">Loading history…</p>;

    if (data.length === 0) {
        return (
            <div data-testid="rider-history-empty" className="rounded-2xl border border-dashed border-border/70 bg-card/50 p-8 text-center text-sm text-muted-foreground">
                No completed deliveries yet.
            </div>
        );
    }

    return (
        <div className="space-y-3" data-testid="rider-history-page">
            <h1 className="text-xl font-extrabold">Delivery history</h1>
            {data.map((d) => (
                <div key={d.id} data-testid={`rider-history-${d.id}`} className="rounded-2xl border border-border/70 bg-card p-4 shadow-soft">
                    <div className="flex items-start justify-between gap-2">
                        <div>
                            <p className="font-bold">{d.order?.number}</p>
                            <p className="text-xs text-muted-foreground">
                                {d.order?.address.city} · {d.order?.item_count} items · {rupee(d.order?.total || 0)}
                            </p>
                        </div>
                        <div className="text-right">
                            <span
                                className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-[10px] font-bold uppercase ${
                                    d.status === "delivered"
                                        ? "bg-emerald-500/10 text-emerald-700"
                                        : "bg-rose-500/10 text-rose-700"
                                }`}
                            >
                                {d.status === "delivered" ? <CheckCircle2 className="h-3 w-3" /> : <XCircle className="h-3 w-3" />}
                                {d.status}
                            </span>
                            <p className="mt-1 text-xs font-bold text-emerald-700">
                                +{rupee(d.earnings)}
                            </p>
                        </div>
                    </div>
                    <p className="mt-2 text-[11px] text-muted-foreground">
                        {d.delivered_at ? new Date(d.delivered_at).toLocaleString("en-IN") : ""}
                    </p>
                </div>
            ))}
        </div>
    );
}
